import mq from '../../styles/mq';

export const gap = 0;

export const growFactor = 2; // 1.5 times the original size

const slickSettings = (defaultSlides, breakpoints, others) => {
  const responsive = breakpoints.map(([breakpoint, slides]) => {
    const smallScreenSettings = slides <= 2 ? {
      dots: false,
      infinite: false,
    } : {};

    return {
      breakpoint,
      settings: {
        slidesToShow: slides,
        slidesToScroll: slides,
        ...others,
        ...smallScreenSettings
      }
    };
  });

  return {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: defaultSlides,
    slidesToScroll: defaultSlides,
    draggable: false,
    swipeToSlide: true,
    swipe: true,
    arrows: true,
    responsive,
    ...others
  };
};

export const settingsFriends = slickSettings(7, [
  [1400, 6],
  [1200, 5],
  [1000, 4],
  [800, 3],
  [600, 2],
  [480, 1],
], { variableWidth: false });

export const settingsVideos = slickSettings(5, [
  [1400, 4],
  [1000, 3],
  [800, 2],
  [600, 1],
], { variableWidth: false });

export const settingsAlbums = slickSettings(3, [
  [800, 2],
  [600, 1],
], { variableWidth: false });
